<div class="gmmappin-modal">
  <div class="gmmappin-body">
    <div class="modal-header-custom d-flex justify-content-between align-items-start mb-3">
      <div>
        <h3 class="modal-title">Add from your vault</h3>
        <p class="modal-sub">Pick something from your Content Vault to pin at this spot.</p>
      </div>
      <button type="button" class="pcm-close" (click)="activeModal.dismiss()" aria-label="Close">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>
    <!-- Filters Section -->
    <div class="filters-container mb-4">
      <div class="row align-items-center">
        <div class="col-md-1">
          <p class="filters-label m-0">Filters:</p>
        </div>
        <div class="col-md-3">
          <div class="acc-card-group acc-genre">
            <div class="lbname">Genre:</div>
            <input type="text" [value]="mapGenre" readonly class="locked-input">
          </div>
        </div>
        <div class="col-md-5">
          <div class="acc-card-group acc-gamesys">
            <div class="lbname">Game System:</div>
            <ng-select
              [items]="selectedGameGenreCategoryItems"
              bindLabel="value"
              bindValue="value"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="selectedGameSystem"
              placeholder="Select Systems"
              class="wt-select limited-height-select" appendTo="body"
              [hideSelected]="false"
              (change)="onFilterChange()">
            </ng-select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="acc-card-group acc-contenttype">
            <div class="lbname">Type:</div>
            <ng-select class="wt-select" [(ngModel)]="selectedType" (change)="onFilterChange()" [items]="gameTypeList"
              bindValue="value" bindLabel="value" placeholder="All Types" [clearable]="true" appendTo="body">
              <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'All Types' }}</span></ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive ccv-table">
      @if (isLoading) {
        <div class="d-flex justify-content-center align-items-center w-100" style="min-height: 160px;">
          <div class="text-center">
            <span class="spinner-border text-light mb-3" role="status" aria-hidden="true"></span>
            <p class="text-light">Loading Content...</p>
          </div>
        </div>
      }
      @if (!isLoading) {
        <table class="table">
          <thead>
            <tr>
              <th></th> <!-- Action -->
              <th (click)="sort('content_title')" class="sortable-header">
                <div class="header-content">
                  <span>Module Name</span>
                  <span class="sort-icon" [class.active]="sortColumn === 'content_title'">
                    @if (sortColumn !== 'content_title' || sortDirection === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    }
                    @if (sortColumn === 'content_title' && sortDirection === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    }
                  </span>
                </div>
              </th>
              <th (click)="sort('gamesystem')" class="sortable-header">
                <div class="header-content">
                  <span>Game System</span>
                  <span class="sort-icon" [class.active]="sortColumn === 'gamesystem'">
                    @if (sortColumn !== 'gamesystem' || sortDirection === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    }
                    @if (sortColumn === 'gamesystem' && sortDirection === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    }
                  </span>
                </div>
              </th>
              <th (click)="sort('type')" class="sortable-header">
                <div class="header-content">
                  <span>Content Type</span>
                  <span class="sort-icon" [class.active]="sortColumn === 'type'">
                    @if (sortColumn !== 'type' || sortDirection === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    }
                    @if (sortColumn === 'type' && sortDirection === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    }
                  </span>
                </div>
              </th>
              <th (click)="sort('playtime')" class="sortable-header text-center">
                <div class="header-content justify-content-center">
                  <span>Playtime (hrs)</span>
                  <span class="sort-icon" [class.active]="sortColumn === 'playtime'">
                    @if (sortColumn !== 'playtime' || sortDirection === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    }
                    @if (sortColumn === 'playtime' && sortDirection === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    }
                  </span>
                </div>
              </th>
              <th (click)="sort('partyaverage')" class="sortable-header text-center">
                <div class="header-content justify-content-center">
                  <span>Average Level</span>
                  <span class="sort-icon" [class.active]="sortColumn === 'partyaverage'">
                    @if (sortColumn !== 'partyaverage' || sortDirection === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    }
                    @if (sortColumn === 'partyaverage' && sortDirection === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    }
                  </span>
                </div>
              </th>
              <th (click)="sort('party_max_size')" class="sortable-header text-center">
                <div class="header-content justify-content-center">
                  <span># of Players</span>
                  <span class="sort-icon" [class.active]="sortColumn === 'party_max_size'">
                    @if (sortColumn !== 'party_max_size' || sortDirection === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    }
                    @if (sortColumn === 'party_max_size' && sortDirection === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                    }
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @if (contentCreatorData.length === 0) {
              <tr class="pcm-empty-row">
                <td colspan="7">
                  <strong>Nothing in your vault for this genre yet.</strong>
                  <span>Content you create for this kind of world shows up here, ready to pin on the map.</span>
                </td>
              </tr>
            }
            @for (content of contentCreatorData; track content) {
              <tr class="value-container">
                <td>
                  <button type="button" class="btn btn-green" (click)="selectContent(content)">
                    Select
                  </button>
                </td>
                <td class="text-ellipsis">{{ content.content_title }}</td>
                <td>{{ content.gamesystem }}</td>
                <td>{{ content.type }}</td>
                <td>{{ content.playtime }}</td>
                <td>{{ content.partyaverage }}</td>
                <td>{{ content.party_max_size }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
